import { IconButton, Switch } from "@chakra-ui/react";
import { useState } from "react";
import { RiDeleteBinLine, RiFileEditLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import CTable from "../../../components/Table/table";
import { restrictChapterRequest } from "../../../modules/admin-modules/chapters/Actions";
import { openCreateChapterModel } from "../../../modules/admin-modules/models/Actions";
import { deleteTeacherRequest } from "../../../modules/superadmin-modules/teachers/Actions";

const TeachersTable = ({ setAdd, setSelectedData }) => {
  const { teachers, isLoading } = useSelector(
    (state) => state.superadminTeachers
  );
  const dispatch = useDispatch();
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });
  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };
  const departmentLabels = {
    0: "national",
    1: "ig",
    2: "american",
    3: "college",
  };

  const Data = teachers?.map((data) => {
    return {
      ...data,
      id: data?.id,
      name: data?.name,
      department: departmentLabels[data?.department] || data?.department || "-",
      restrict: (
        <Switch
          onChange={() => {
            let formData = new FormData();
            formData.append("restrict", data?.restrict == 0 ? 0 : 1);
            formData.append("_method", "PUT");
            dispatch(
              restrictChapterRequest({
                formData: formData,
                id: data?.id,
              })
            );
          }}
          isChecked={data?.restrict == 0 ? false : true}
        />
      ),

      edit: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiFileEditLine />}
          onClick={() => {
            setAdd(false);
            dispatch(openCreateChapterModel());
          }}
        />
      ),
      delete: (
        <IconButton
          variant="outline"
          border="0"
          color="gray.600"
          aria-label="Call Sage"
          fontSize="20px"
          icon={<RiDeleteBinLine color="red" />}
          onClick={() => dispatch(deleteTeacherRequest(data?.id))}
        />
      ),
    };
  });
  const columns = [
    {
      Header: " اسم المدرس",
      accessor: "name",
    },
    {
      Header: "القسم",
      accessor: "department",
    },

    {
      Header: " Restrict",
      accessor: "restrict",
    },

    {
      Header: "تعديل",
      accessor: "edit",
    },
    {
      Header: "حذف",
      accessor: "delete",
    },
  ];

  return (
    <CTable
      selectedData={viewData}
      Columns={columns}
      Data={Data}
      path={"openModel"}
      Actions
      Title={``}
      subTitle=""
      btnTitle=""
      placeHolder=""
      noSearchBar={true}
      noFilter={true}
      footerBtnTitle
      filterList
      addButton
      addButtonTitle=""
      setPage={setPage}
      setPerPage={setPerPage}
      currentpage={pageNumber}
      setPageNumber={setPageNumber}
      noSecondSearchBar={true}
      isLoading={isLoading}
      perPage={size}
      totalPage={Math.ceil(teachers?.length / 10)}
    />
  );
};

export default TeachersTable;
